import { Grid } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { setActiveActionCard } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Feedback from "components/common/Feedback";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { FEEDBACK_TIMER } from "utils/CommonConstants";
import { planTypes } from "utils/Types";
import { setIsCardVisited } from "../library/functionalArea/individualAction.slice";
import AllPlans from "./AllPlans";
import ActionCardDialogsContext from "./Context";
import MyPlans from "./MyPlans";
import "./index.scss";

interface Props {
  item?: any;
  planType: string;
  sectionId?: any;
  planId?: number;
  multiCardSelect?: boolean;
  allAssignees?: any;
  isDisabled?: boolean;
}

function ActionCard(props: Props) {
  const translate = useTranslate();
  const { isDisabled = false } = props;
  const dispatch = useAppDispatch();
  const { cardId }: any = useParams();
  const { isMobileScreen }: any = ThemeContext;
  const { item, planType, sectionId, planId, multiCardSelect = false, allAssignees } = props;
  const { id, timeEstimateMinutes, name: title, status, dueDate } = item;
  const { setIsOpenViewActionDialog, setIsOpenPlanDetaiLDialog } = useContext(ActionCardDialogsContext);
  const individualActionDetail = useAppSelector((state: any) => state.individualAction.actionDetails);
  const isRedirectFromNotification: any = useAppSelector((state) => state.myPlanDetails.isRedirectFromNotification);
  const isCardVisited = useAppSelector((state: any) => state.individualAction.isCardVisited);
  const selectedCards = useAppSelector((state) => state?.app?.selectedCards);
  const isCurrentCardSelected = !!selectedCards.cardList.find((item: any) => item.id === id);
  const [showWarning, setShowWarning] = useState(false);
  const [searchParams] = useSearchParams();
  const isShareable = searchParams.get("isshareable") as string;
  const openCard = searchParams.get("openCard") as string;

  useEffect(() => {
    // eslint-disable-next-line
    if (item.id == cardId) {
      dispatch(setActiveActionCard({ planId, planType, sectionId, cardId: item.id, ...item }));
      if (planType === planTypes.MulipleAssign) setIsOpenPlanDetaiLDialog(false);
      (isShareable || isRedirectFromNotification || openCard) && setIsOpenViewActionDialog(true);

      return;
    }
    if (individualActionDetail.id && !isCardVisited) {
      dispatch(setActiveActionCard(individualActionDetail));
      setIsOpenViewActionDialog(true);
      dispatch(setIsCardVisited(true));
    }
  }, [individualActionDetail]);

  return (
    <>
      <Feedback
        form=""
        message={translate("myPlan.actionDisabled.feedback")}
        onCloseChange={() => setShowWarning(false)}
        actionStatus={{ shouldShow: showWarning, variant: "warning", timer: FEEDBACK_TIMER }}
      />
      <Card
        sx={{
          width: { xs: `100%`, sm: `244px` },
          minHeight: isMobileScreen ? "158px" : "194px",
          minWidth: isMobileScreen ? "343px" : "244px",
          border: isCurrentCardSelected
            ? `2px solid ${tokens.Border.General.Color}`
            : `1px solid ${tokens.Border.General.Tertiary}`,
          borderRadius: "12px",
          padding: 0,
          margin: isMobileScreen ? "16xp 0" : "0",
          boxShadow: "none",
          opacity: isDisabled ? "0.35" : "auto",
          "&.MuiPaper-root:hover": {
            cursor: !isDisabled ? "pointer" : "auto",
            boxShadow: !isDisabled
              ? "0px 10px 25px rgba(100, 116, 139, 0.1), 0px 20px 40px 8px rgba(100, 116, 139, 0.3)"
              : ""
          }
        }}
        onClick={(e) => {
          e.stopPropagation();
          if (!isDisabled) {
            dispatch(setActiveActionCard({ planId, planType, sectionId, cardId: item.id, ...item }));
            if (planType === planTypes.MulipleAssign) setIsOpenPlanDetaiLDialog(false);
            setIsOpenViewActionDialog(true);
          } else {
            setShowWarning(true);
          }
        }}
      >
        <CardContent
          sx={{
            height: "100%",
            padding: "16px",
            "&:last-child": {
              paddingBottom: "22px"
            }
          }}
        >
          {planType === planTypes.AllPlans && (
            <AllPlans
              planId={planId}
              title={title}
              timeEstimateMinutes={timeEstimateMinutes}
              multiCardSelect={multiCardSelect}
              item={item}
              sectionId={sectionId}
            />
          )}
          {planType === planTypes.MyPlans && (
            <MyPlans
              planId={planId}
              cardId={id}
              sectionId={sectionId}
              assigneeList={allAssignees}
              status={status}
              title={title}
              dueDate={dueDate}
              multiCardSelect={multiCardSelect}
              item={item}
              isDisabled={isDisabled}
            />
          )}
          {planType === planTypes.MulipleAssign && (
            <Grid height="100%" display={"flex"} alignItems={"center"} justifyContent={"center"}>
              <Typography
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "3",
                  WebkitBoxOrient: "vertical"
                }}
                variant="body2"
                color={tokens.Text.General.PrimaryHeadline}
              >
                {title}
              </Typography>
            </Grid>
          )}
        </CardContent>
      </Card>
    </>
  );
}
export default ActionCard;
